import {createContext} from 'react';

import {AsyncStatusesEnum} from '../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {ChannelModel} from '../../../../libs/shared/core/src/models/api/channelModel';
import {ChannelPreferenceFrontChatAiKnowledgeSourceModel} from '../../../../libs/shared/core/src/models/api/channelPreferencesModel';
import {DecisionTreeModel} from '../../../../libs/shared/core/src/models/api/decisionTrees/decisionTreeModel';
import {InboxModel} from '../../../../libs/shared/core/src/models/api/inboxModel';
import {KnowledgeBaseModel} from '../../../../libs/shared/core/src/models/api/knowledgeBaseModel';
import {FlowBuilderContextType} from '../../../../libs/shared/ui/src/components/decisionTrees/flowBuilder/flowBuilderContext';
import {TagModel} from '../../../models/api/tagModel';
import {
  ChatBotBuilderErrorReasonsEnum,
  ChatBotBuilderFeatureFlags,
  ChatBotBuilderNodeData,
  ChatBotBuilderState,
} from './types';

/*
 * Types.
 */

export interface ChatBotBuilderContextType
  extends FlowBuilderContextType<ChatBotBuilderNodeData, ChatBotBuilderState> {
  featureFlags: ChatBotBuilderFeatureFlags;
  onSubtreeCreate: (name: string) => Promise<DecisionTreeModel | undefined>;
  onSubtreeSelected: (model: DecisionTreeModel) => void;
  computeNumSubtreeUses: (subtree?: DecisionTreeModel) => number;
  channel?: ChannelModel;
  inbox?: InboxModel;
  idTagMap: Record<number, TagModel>;
  isKnowledgeBaseEnabledForAi: boolean;
  knowledgeBase: KnowledgeBaseModel | undefined;
  aiKnowledgeSources: ReadonlyArray<ChannelPreferenceFrontChatAiKnowledgeSourceModel>;
  errorReason?: ChatBotBuilderErrorReasonsEnum;
  hasPremiumFeatures?: boolean;
  isOnLegacyGrowthScalePlan?: boolean;
  isSubtree?: boolean;
  selectedSubtreeId?: number;
  subtrees: ReadonlyArray<DecisionTreeModel>;
  subtreesStatus: AsyncStatusesEnum;
  // Nodes disabled due to be part of an unavailable path.
  disabledNodeIds: ReadonlyArray<string>;
  isSimpleEditor?: boolean;
  isBranchStepDisabledForSubtree?: boolean;
}

/*
 * Context.
 */

export const ChatBotBuilderContext = createContext<ChatBotBuilderContextType | undefined>(undefined);
